import React, { Component } from 'react';
import TableContent from '../ContenidoTablas/Excepciones';
import { anularExp, changeState } from '../../../utils/Excepciones';
import AccionSolicitud from '../../modals/SolicitudExcepcional/AccionSolicitud';
import EnviarNotificacion from '../../modals/SolicitudExcepcional/EnviarNotificacion';
import EstadoSolicitud from '../../modals/SolicitudExcepcional/EstadoSolicitud';
import SolExcep from '../../modals/SolicitudExcepcional';

class Excepciones extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rowSelected: '',
      modal: '',
      action: '',
      notificarModal: false,
      editarModal: false,
      excepcionSeleccionada: '',
      estadoSeguimiento:{}
    };
  }

  showModal = (name, action) => this.setState({ modal: name, action })
  closeModal = () => this.setState({ modal: '', action: '' })

  openEditarSolicitud = (excepcion) => {
    this.setState({ editarModal: true, excepcionSeleccionada: excepcion });
  }

  closeEditarSolicitud = () => this.setState({ editarModal: false, excepcionSeleccionada: '' })

  openNotificar = (excepcion) => {
    this.setState({ notificarModal: true, excepcionSeleccionada: excepcion });
  }

  closeNotificar = () => this.setState({ notificarModal: false, excepcionSeleccionada: '' })

  toggleRow = (index) => {
    if (index === this.state.rowSelected) {
      this.setState({ rowSelected: '' });
    } else {
      this.setState({ rowSelected: index });
    }
  }

  anular = (codigo) => {
    anularExp(codigo)
      .then(({ data }) => {
        this.props.openAlert(data);
        this.closeModal();
        this.props.fetchAutorizacionesExcepcionales(this.props.fdvID);
      });
  }

  cambiarEstado = (codigo, estado) => {
    changeState(codigo, estado)
      .then(({ data }) => {
        this.props.openAlert(data);
        this.closeModal();
        this.props.fetchAutorizacionesExcepcionales(this.props.fdvID);
      });
  }

  cambiarEstadoSeguimiento = () => {
    this.props.saveAutorizacionesExcepcionales(this.state.estadoSeguimiento.codSolicitud,this.state.estadoSeguimiento.codEstado)
    .then(result => {
      this.props.fetchAutorizacionesExcepcionales(this.props.fdvID);
      this.props.openAlert(result.payload.data);
    });
    this.closeModal();
  }

  showEstadoSeguimiento = (codEstado, descripcion, codSolicitud) => {
      this.setState({estadoSeguimiento:{'codEstado':codEstado,'codSolicitud':codSolicitud}})
      this.showModal(descripcion);
  }

  render() {
    const { rowSelected } = this.state;
    const { excepciones } = this.props;

    return (
      <section className='fdv-section tab-pane active' id='autorizaciones'>
        <header className='fdv-section-head'>
          <h5 className='fdv-section-title'>Autorizaciones excepcionales</h5>
          <div className='fdv-section-actions'>
            <a className='btn btn-primary btn-sm' onClick={(e) => this.props.handlePermissions(e) && this.props.openModal('SolExcep')} data-permisos='ind_crear_solicitud_excep'>Nueva autorización</a>
          </div>
        </header>
        <div className='tableWrapper hidden-xs'>
          <table className='table table-hover table-accordion'>
            <thead className='table-head'>
              <tr>
                <th>Nº Solic.</th>
                <th>Estado</th>
                <th>Tipo</th>
                <th>Resp. Regulariz.</th>
                <th>Est. de Seguimiento</th>
                <th>Fª Est. Regul.</th>
                <th />
              </tr>
            </thead>
            <TableContent
              rowSelected={rowSelected}
              excepciones={excepciones}
              cambiarEstado={this.cambiarEstado}
              anular={this.anular}
              toggleRow={this.toggleRow}
              showEstadoSeguimiento={this.showEstadoSeguimiento}
              showModal={this.showModal}
              closeModal={this.closeModal}
              openNotificar={this.openNotificar}
              seguimientoAutorizaciones={this.props.seguimientoAutorizaciones}
              cambiarEstadoSeguimiento={this.cambiarEstadoSeguimiento}
              openEditarSolicitud={this.openEditarSolicitud}
            />
          </table>
        </div>
        <div className='visible-xs'>
          {
            this.props.excepciones.map(excepcion => (
              <div className='tableMob' key={excepcion.codSolicitud}>
                <div className='tableMob-mainContent'>
                  <label className='tag tag-TopRight tag-yellow' htmlFor='cod'>{excepcion.codEstadoRegul}</label>
                  <div className='tableMob-header'>
                    <div className='tableMob-check'>
                      <div className='checkbox'>
                        <label htmlFor='check'>
                          <input type='checkbox' />
                          <div className='checkbox-skin' />
                        </label>
                      </div>
                    </div>
                    <h3 className='tableMob-title'>{excepcion.nomCliente}</h3>
                  </div>
                  <ul className='tableMob-content row'>
                    <li className='tableMob-content-item col-xs-6'>
                      <p className='labelInfo'>N° Solic.</p>
                      <p>{excepcion.codSolicitud}</p>
                    </li>
                    <li className='tableMob-content-item col-xs-6'>
                      <p className='labelInfo'>Tipo.</p>
                      <p>{excepcion.desTipoAutExcepcional}</p>
                    </li>
                    <li className='tableMob-content-item col-xs-6'>
                      <p className='labelInfo'>Resp. Regulariz.</p>
                      <p>{excepcion.codUsuarioRegul}</p>
                    </li>
                    <li className='tableMob-content-item col-xs-6'>
                      <p className='labelInfo'>F° Est. Regul.</p>
                      <p>{excepcion.fecEstimadaRegul}</p>
                    </li>
                  </ul>
                  <button className='btn-link tableMob-expand' data-toggle='collapse' data-target={'#detalleAut'+excepcion.codSolicitud}>
                    <span className='tableMob-expandLabel'>Ver Más</span>
                    <span className='tableMob-reduceLabel'>Ver Menos</span>
                  </button>
                </div>
                <div className='tableMob-extraContent collapse' id={'detalleAut'+excepcion.codSolicitud}>
                  <div className='row'>
                    <div className='col-xs-6'>
                      <p className='labelInfo'>Resp. de Autorización</p>
                      <p>{excepcion.codUsuarioAutoriza}</p>
                    </div>
                    <div className='col-xs-6'>
                      <p className='labelInfo'>Fª de Autorización</p>
                      <p>{excepcion.fecAutoriza}</p>
                    </div>
                  </div>
                  <div className='row'>
                    {
                      !excepcion.numPedidosVeh &&
                        <div className='col-xs-6'>
                          <p className='labelInfo'>Cant. Unidades</p>
                          <p>{excepcion.canVehiculos}</p>
                        </div>
                    }
                    <div className='col-xs-6'>
                      <p className='labelInfo'>Fº Creación</p>
                      <p>{excepcion.fecCreacion}</p>
                    </div>
                    <div className='col-xs-12'>
                      <p className='labelInfo'>Observaciones</p>
                      <p>{excepcion.obsSolicitud}</p>
                    </div>
                  </div>
                  {
                    excepcion.numPedidosVeh &&
                      <div className="row">
                        <div className="col-xs-12">
                          <p className="labelInfo">N° de Pedidos</p>
                          <p>{excepcion.numPedidosVeh}</p>
                        </div>
                      </div>
                  }
                  <div className='row'>
                    <div className='col-xs-6'>
                      {
                        excepcion.codEstadoAut === 'P' &&
                          <button className='btn-sm btn btn-primary btn-block'
                            onClick={() => this.showModal('Aprobar',
                              () => this.cambiarEstado(excepcion.codSolicitud,'A'))}>Aprobar
                          </button>
                      }
                    </div>
                    <div className='col-xs-6'>
                      {
                        excepcion.codEstadoAut === 'P' &&
                          <button className='btn-sm btn btn-default btn-block'
                            onClick={() => this.showModal('Rechazar',
                            () => this.cambiarEstado(excepcion.codSolicitud,'R'))}>Rechazar
                          </button>
                      }
                    </div>
                    <div className='col-xs-12 autDetailMob-secActions'>
                      <button className='btn-sm btn-link autDetailMob-secActions-item'
                        onClick={() => this.openNotificar(excepcion)}>Enviar notificación
                      </button>
                      <button className='btn-sm btn-link autDetailMob-secActions-item'
                        onClick={() => this.openEditarSolicitud(excepcion)}>Editar
                      </button>
                      <button className='btn-sm btn-link autDetailMob-secActions-item'
                        onClick={() => this.showModal('Inactivar',
                        () => this.anular(excepcion.codSolicitud))}>Inactivar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
        {
            (['Aprobar', 'Rechazar', 'Inactivar'].indexOf(this.state.modal)>=0) &&
            <AccionSolicitud
              actionName={this.state.modal}
              closeModal={this.closeModal}
              action={this.state.action}
            />
        }
        {
            (this.props.seguimientoAutorizaciones.map(entry => entry.descripcion).indexOf(this.state.modal) >=0 ) &&
            <EstadoSolicitud
              actionName={this.state.modal}
              closeModal={this.closeModal}
              action={this.state.action}
              cambiarEstadoSeguimiento={this.cambiarEstadoSeguimiento}
              showEstadoSeguimiento={this.showEstadoSeguimiento}
            />
        }
        {
          this.state.notificarModal &&
            <EnviarNotificacion
              closeModal={this.closeNotificar}
              excepcion={this.state.excepcionSeleccionada}
              openAlert={this.props.openAlert}
            />
        }
        {
          this.state.editarModal &&
            <SolExcep
              closeModal={this.closeEditarSolicitud}
              excepcion={this.state.excepcionSeleccionada}
              openAlert={this.props.openAlert}
              fdvID={this.state.excepcionSeleccionada.numFichaVtaVeh}
              fichaVenta={this.state.excepcionSeleccionada}
              fetchAutorizacionesExcepcionales={this.props.fetchAutorizacionesExcepcionales}
            />
        }
      </section>
    );
  }
}

export default Excepciones;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Excepciones.js